import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CommonConstants } from '../../../../common/constants/common-constants';
import { ItemCategoriesResultEntity } from '../../shared/model/itemcategoriesresponse';
import { ItemTypesResultEntity } from '../../shared/model/itemtypesresponse';
import { ServicesResponse } from '../model/serviceitemsresponse';
import { Subject, Observable } from 'rxjs';
import {tap} from 'rxjs/internal/operators';

@Injectable()
export class ServiceItemsListService {

    private _servicesCount = new Subject<number>();
    private _serviceCatalogCount = new Subject<number>();
    constructor(public http: HttpClient) {
    }
    // function call to fetch item list
    public getServiceItemsList(params: HttpParams) {
        let data = this.http.get<ServicesResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/ci/items', { params })
        .pipe(tap(resp => {
            this._servicesCount.next(resp.myServiceCount);
            this._serviceCatalogCount.next(resp.serviceCatalogCount);
        }
        )
        );
        return data;
    }

    public getItemCategories() {
        const params = new HttpParams()
            .set('itemOption', 'SERVICEITEM');
        return this.http.get<ItemCategoriesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allCategories', { params });
    }

    public getItemTypes() {
        const params = new HttpParams()
            .set('itemOption', 'SERVICEITEM');
        return this.http.get<ItemTypesResultEntity[]>(CommonConstants.SERVICE_VERSION_PATH_V1 +
            '/customer/allItemTypes', { params });
    }

    public getServiceCount(): Observable<number> {
        return this._servicesCount;
    }

    public getServiceCatalogCount(): Observable<number> {
        return this._serviceCatalogCount;
    }
}
